var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 5C7.40625 5 7.71875 5.34375 7.71875 5.75V7H12.25V5.75C12.25 5.34375 12.5625 5 13 5C13.4062 5 13.75 5.34375 13.75 5.75V7H15C16.0938 7 17 7.90625 17 9V11H4.46875V19C4.46875 19.2812 4.71875 19.5 4.96875 19.5H11.875C12.25 20.0938 12.75 20.625 13.3125 21H5C3.875 21 3 20.125 3 19V9C3 7.90625 3.875 7 5 7H6.25V5.75C6.25 5.34375 6.5625 5 7 5H6.96875ZM21 16.5C21 19 18.9688 21 16.5 21C14 21 11.9688 19 11.9688 16.5C11.9688 14.0312 14 12 16.5 12C18.9688 12 21 14.0312 21 16.5ZM15.9688 14.5V16.5C15.9688 16.7812 16.2188 17 16.4688 17H18C18.25 17 18.5 16.7812 18.5 16.5C18.5 16.25 18.25 16 18 16H16.9688V14.5C16.9688 14.25 16.75 14 16.4688 14C16.2188 14 15.9688 14.25 15.9688 14.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.9172cc2bba06629b49266a4149e5daf8.svg";
export { ForwardRef as ReactComponent };